import styled, { keyframes, css } from "styled-components"

export const SkillsWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom: 50px;
    background-color: #EBF2FF;
    padding: 40px 20px;
`

export const SkillsContainer = styled.div`
    width: 70%;
    border-radius: 25px;
    display: flex;
    flex-wrap: wrap;
    padding: 40px 20px;
    justify-content: center;
    gap: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(59, 130, 246, 0.1);
    background-color: white;

    @media(max-width: 1025px) {
        justify-content: center;
        width: 90%;
    }
`

export const SkillTagItems = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: linear-gradient(135deg, #3b82f6, #2563eb);
`


const skillTagFadin = keyframes`
0% {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`

export const SkillTag = styled.div`
    width: 150px;
    height: 150px; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #dae4f4;
    border-radius: 50%;
    background-color: #DDE5F3;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    animation: ${({ $isVisible }) => $isVisible ? css`${skillTagFadin} 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards` : 'none'};
    opacity: ${({ $isVisible }) => $isVisible ? 1 : 0};
    transform: ${({ $isVisible }) => $isVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.8)'};

    @media(max-width: 650px) {
        width: 100px;
        height: 100px; 
        font-size: 10px;

        svg {
            font-size: 15px;
        }
    }
    
    &:hover {
        box-shadow: 0 12px 40px rgba(59, 130, 246, 0.25);
        transform: translateY(-4px) scale(1.05);
        background: linear-gradient(135deg, #e0f2fe, #bbdefb);
        border-color: #3b82f6;
    }
`

export const SkillsHeader = styled.h1`
    padding: 20px;
    border-bottom: 3px solid #3b82f6;   
    text-align: center;
    margin-bottom: 20px;
    position: relative;
    
`

export const Icon = styled.i`
    color: #2563eb;
    transform: ${(props) => (props.$hoveredIndex ? 'rotate(15deg) scale(1.1)' : 'rotate(0deg) scale(1)')};
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    @media(max-width: 650px) {
        font-size: 10px;
    }
`
